type BrandMarkProps = {
  size?: number;
  className?: string;
};

/** Inline brand mark — same asset as `/favicon.svg` (production). */
export function BrandMark({ size = 36, className = 'brand__mark' }: BrandMarkProps) {
  return (
    <img
      src="/favicon.svg"
      alt=""
      width={size}
      height={size}
      className={className}
      aria-hidden
      decoding="async"
    />
  );
}
